module.exports = __webpack_public_path__ + "static/img/training-logo.e84fb122.png";